module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Jan":"Jan","Feb":"Feb","Mar":"Mar","Apr":"Apr","May":"May","Jun":"Jun","Jul":"Jul","Aug":"Aug","Sep":"Sep","Oct":"Oct","Nov":"Nov","Dec":"Dec"},"vi":{"Jan":"Tháng 1","Feb":"Tháng 2","Mar":"Tháng 3","Apr":"Tháng 4","May":"Tháng 5","Jun":"Tháng 6","Jul":"Tháng 7","Aug":"Tháng 8","Sep":"Tháng 9","Oct":"Tháng 10","Nov":"Tháng 11","Dec":"Tháng 12"}}')
  delete Component.options._Ctor
}
